import { bool, num, str } from 'envalid';

export class VaultEnvConfig {
  private static readonly schema = {
    VAULT_RETENTION_DAYS: num({
      default: 90,
      desc: 'Number of days soft-deleted vaults are retained before automatic purge',
      example: '90',
    }),
    COLLAB_INTERNAL_URL: str({
      default: undefined,
      desc: 'Base URL of the collaboration server for internal API calls (e.g., room occupancy checks)',
      example: 'http://localhost:8200',
    }),
    COLLAB_INTERNAL_SECRET: str({
      default: undefined,
      desc: 'Shared secret for authenticating internal calls to the collaboration server',
    }),
    USE_TEST_VAULTS: bool({
      default: false,
      desc: 'Enable loading vaults from fixture data instead of the database (requires TEST_VAULT_PATH)'
    }),
    TEST_VAULT_PATH: str({
      default: undefined,
      desc: 'Filesystem directory that contains test vault fixtures used when USE_TEST_VAULTS=TRUE',
      example: '/tmp/inovisum-test-vaults'
    }),
    GITHUB_BACKUP_ORG: str({
      default: undefined,
      desc: 'GitHub organization for managed vault backups (optional)',
      example: 'inovisum-vaults',
    }),
    GITHUB_APP_ID: str({
      default: undefined,
      desc: 'GitHub App ID for repository management (required if GITHUB_BACKUP_ORG is set)',
      example: '123456',
    }),
    GITHUB_APP_PRIVATE_KEY: str({
      default: undefined,
      desc: 'GitHub App private key in PEM format (required if GITHUB_BACKUP_ORG is set)',
      example: '-----BEGIN RSA PRIVATE KEY-----\\n...\\n-----END RSA PRIVATE KEY-----',
    }),
    GITHUB_APP_INSTALLATION_ID: str({
      default: undefined,
      desc: 'GitHub App installation ID for the backup organization (required if GITHUB_BACKUP_ORG is set)',
      example: '12345678',
    }),
  } as const;

  private constructor() {}

  public static getSchema() {
    return VaultEnvConfig.schema;
  }
}
